/* src/app/features/player/components/player-controls/components/player-controls-series-episodes/player-controls-series-episodes.scss */
:host {
  position: absolute;
  right: -40px;
  bottom: 40px;
  z-index: 10;
  padding-bottom: 20px;
  transform: translateY(10px);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity 0.25s ease,
    transform 0.25s ease,
    visibility 0.25s ease;
}
:host ::ng-deep .p-select {
  border-radius: 18px;
  min-width: 150px;
}
:host ::ng-deep .p-select .p-select-dropdown-icon {
  height: 15px;
}
.wrapper {
  position: relative;
  overflow: hidden;
  background-color: var(--background_primary_8);
  box-shadow: 0 6px 16px var(--background_primary_5);
  border-radius: 15px;
  padding: 20px;
  min-width: 450px;
  min-height: 200px;
}
.select-season-container {
  margin-bottom: 20px;
}
.episodes-container {
  position: relative;
  padding-top: 12px;
  width: 450px;
  max-height: 520px;
  min-height: 200px;
  overflow: hidden;
  overflow-y: scroll;
}
.episodes-container:has(player-controls-series-episode:first-child .badge-container) {
  padding-top: 28px;
}
.no-episodes {
  text-align: center;
  color: var(--text_secondary);
  font-size: 16px;
  margin-top: 20px;
}
/*# sourceMappingURL=player-controls-series-episodes.css.map */
